import { Injectable } from '@angular/core';
import 'rxjs/Rx';
import { ApiService } from '../authentication/guards/api.service';
import { BehaviorSubject } from 'rxjs/BehaviorSubject';
import { Observable } from 'rxjs/Observable';
import { IOption } from 'ng-select';

@Injectable()
export class UserService {
  constructor(private apiService: ApiService) { }

  create(user) {
    return this.apiService.post('/user', user).map(data => data);
  }

  getListOfUser(id, LangId, InviteFilter) {
    return this.apiService.get('/userlist/' + id + '/' + LangId + '/' + InviteFilter).map(data => data);
  }
  
  getListOfExportUser(id, LangId, InviteFilter) {
    return this.apiService.get('/exportuserlist/' + id + '/' + LangId + '/' + InviteFilter).map(data => data);
  }

  getListOfAllUser(id, LangId) {
    return this.apiService.get('/alluserlist/' + id + '/' + LangId).map(data => data);
  }

  getListOfUserbySelectedUnit(units) {
    return this.apiService.post('/userlistbyunits/', units).map(data => data);
  }

  getListOfLockedUser(id) {
    return this.apiService.get('/lockeduserlist/' + id).map(data => data);
  }

  getUserById(id) {
    var appid = JSON.parse(window.sessionStorage['selectedApp']);
    return this.apiService.get('/user/' + id + '/appid/'+appid['Id']).map(data => data);
    //return this.apiService.get('/user/' + id).map(data => data);
  }

  sendUserMail(user) {
    return this.apiService.post('/usersendemail/', user).map(data => data);
  }

  lockUser(id, type) {
    var appid = JSON.parse(window.sessionStorage['selectedApp']);    
    if(appid['Id'] > 0){
      return this.apiService.get('/lockedusers/' + id + '/' + type).map(data => data);
    }else{
      return this.apiService.get('/lockeduserssa/').map(data => data);
    }    
  }

  unlockUser(id, appid) {
    return this.apiService.post('/unlockeduser/' + id + '/' + appid).map(data => data);
  }

  addUnitTouser(data) {
    return this.apiService.post('/addunittouser', data).map(data => data);
  }

  getUserProfile(snUserId, snAppId) {
    var snNewUserId = snUserId;
    if(snUserId == '' || snUserId == null){
      snNewUserId = 0;
    }        
    return this.apiService.get('/userprofile/'+snNewUserId+'/'+snAppId).map(data => data);
  }

  getUserprofileimage() {
    return this.apiService.get('/userprofileimage').map(data => data);
  }

  postUserProfile(data) {
    return this.apiService.post('/userprofile', data).map(data => data);
  }

  getUserLoginHistory(snUserId) {
    var snNewUserId = snUserId;
    if(snUserId == '' || snUserId == null){
      snNewUserId = 0;
    } 
    return this.apiService.get('/userloginhistory/'+snNewUserId).map(data => data);
  }

  fileUpload(files, appId) {
    return this.apiService.fileUpload('/fileupload/' + appId + '/appid/', files).map(data => data);
  }

  ChangePassword(passwordValues) {
    return this.apiService.post('/changepassword', passwordValues).map(data => data);
  }

  clearMobileData(id) {
    return this.apiService.delete('/gdprallmobiledata/' + id).map(data => data);
  }

  deleteMobileAccount(id, appid) {
    return this.apiService.delete('/gdprmobileuseraccount/' + id + '/' + appid).map(data => data);
  }

  inactiveCMSAccount(id, appid, inActive) {
    return this.apiService.delete('/gdprinactivecmsaccount/' + inActive + '/inactive/' + appid + '/app/' + id).map(data => data);
  }

  deleteAndMakeAllCMSUserDataAnonymous(id, appid) {
    return this.apiService.delete('/deleteandmakeallcmsuserdataanonymous/' + id + '/' + appid).map(data => data);
  }

  sendUserInvitation(data, appid, type) {
    return this.apiService.post('/senduserinvitation/' + appid + '/'+ type, data).map(data => data);
  }

  getListOfUnitUsers(id, LangId, InviteFilter,UnitId) {
    return this.apiService.get('/unituserlist/' + id + '/' + LangId + '/' + InviteFilter + '/' + UnitId).map(data => data);
  }

  getApplicationRequestListOfUser(id, LangId, InviteFilter) {
    return this.apiService.get('/userapplicationrequestlist/' + id + '/' + LangId + '/' + InviteFilter).map(data => data);
  }

  approveuserapplicationrequest(userRequestDetails) {
    return this.apiService.post('/approveuserrequestedapplication', userRequestDetails).map(data => data);
    //return this.apiService.get('/approveuserrequestedapplication/' + id + '/' + AppId).map(data => data);
  }

  rejectuserapplicationrequest(id, AppId) {
    return this.apiService.get('/rejectuserrequestedapplication/' + id + '/' + AppId).map(data => data);
  }

  getUserApplicationRequestById(id) { 
    return this.apiService.get('/getuserapplicationrequestdetails/'+id).map(data => data);
  }  

  deleteUserAccount(id) {
    return this.apiService.delete('/deleteuseraccount/' + id).map(data => data);
  }

  getUserAppActivity(snUserId) {
    var snNewUserId = snUserId;
    if(snUserId == '' || snUserId == null){
      snNewUserId = 0;
    } 
    return this.apiService.get('/userappactivity/'+snNewUserId).map(data => data);
  }

  exportInvitedButNotAcceptedUser(id, LangId) {
    return this.apiService.get('/exportinvitedbutnotaccepteduser/' + id + '/' + LangId).map(data => data);
  }

  deleteInvitedButNotAcceptedUser(userData) {
    return this.apiService.post('/deleteinvitedbutnotaccepteduser', userData).map(data => data);
    //return this.apiService.get('/deleteinvitedbutnotaccepteduser/' + id + '/' + LangId).map(data => data);
  }

  userInvitedButNotAccepted(id, LangId) {
    return this.apiService.get('/userinvitedbutnotaccepted/' + id + '/' + LangId).map(data => data);
  }

  getCMSFestivalTheme(AppId){
    return this.apiService.get('/getcmsfestivaltheme/'+AppId).map(data => data);
  }
}



// WEBPACK FOOTER //
// D:/projects/4164_AppsPotr_Backend/production/CMS_prod/src/app/services/user-management/user-management.ts